import { useNavigate } from "@tanstack/react-router";

export const useNavigateLiveQueue = () => {
  const navigate = useNavigate();
  return () => navigate({ to: "/live-queue", replace: true });
};
